import { useState, useEffect } from "react";
import classNames from "classnames";
import * as GameLayout from "ui/templates/Game/LayoutComponents";
import { refrenceTrackIds } from "../EQ/FrequencyFinder/pages/referenceTrackConfig";

interface Props {
  autoToggle: boolean;
  setAutoToggle: (x: (x: boolean) => boolean) => void;
  mobileToolbarStyle: GameLayout.MobileToolbarStyle;
  secondsTillChange: string;
}

export default function MobileFloatingAutoToggleButton({
  autoToggle,
  setAutoToggle,
  mobileToolbarStyle,
  secondsTillChange,
}: Props) {
  return (
    <div className={"md:hidden"}>
      <GameLayout.MobileFloatingToolbar
        toolbarMobileStyle={mobileToolbarStyle}
        onClick={() => setAutoToggle((x) => !x)}
        className="active:scale-95"
      >
        <div className={"flex items-center whitespace-nowrap px-2"}>
          <div
            className={classNames(
              "mr-3 h-[18px] min-h-[18px] w-[18px] min-w-[18px] rounded-full transition-all",
              {
                "bg-red-500": autoToggle,
                "bg-gray-500": !autoToggle,
              }
            )}
          />
          <div className={"text-base font-bold"}>
            Auto Toggle {secondsTillChange}
          </div>
        </div>
      </GameLayout.MobileFloatingToolbar>
    </div>
  );
}
